<template>
    <div class="shadow" >
        <div class="chartStyle " ref="successVsFailChart"></div>
    </div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
// import { start } from 'repl';

am4core.useTheme(am4themes_animated);

export default {
    data(){
        return {
            chart : null,
           
        }
    },
    mounted(){
        this.createChart();
        this.getData();
    },
    watch : {
        '$store.state.updateData' : function(){
            this.getData();
        }
    },
    methods:{
        getData(){
            //for testing purposes
            var length = this.chart.data.length;

            var urlString = "/api/log/graph" + this.$store.state.filterUrl;
            this.$http.get(urlString)
            .then((resp)=>{
                console.log(resp);
                var data = resp.data.data;

                for(var i = 0 ; i < data.length ; i++){
                    data[i].date = new Date(data[i].date);
                }

                this.chart.addData(data, length)
            })
            .catch((err)=>{
                console.log(err);
            })
        },
        sampleData(){
            var data = [{
                "date": new Date(2018, 3, 20),
                "value": 65,
                "value2": 11
                }, {
                "date": new Date(2018, 3, 21),
                "value": 12,
                "value2": 102
                }, {
                "date": new Date(2018, 3, 22),
                "value": 106,
                "value2": 65
                }, {
                "date": new Date(2018, 3, 23),
                "value": 75,
                "value2": 62
                }, {
                "date": new Date(2018, 3, 24),
                "value": 85,
                "value2": 55
                }, {
                "date": new Date(2018, 3, 25),
                "value": 90,
                "value2": 81
            }, {
                "date": new Date(2018, 3, 26),
                "value": 90,
                "value2": 81
            }];

            return data;
        },
        createChart(){
            this.chart = am4core.create( this.$refs.successVsFailChart , am4charts.XYChart);
            
            this.chart.colors.list = [
                am4core.color("#68edb6"),
                am4core.color("#ff7152"),

            ]

            //comment this when developing the API
            // this.chart.data = this.sampleData();

            //create axis x
            let dateAxis = this.chart.xAxes.push(new am4charts.DateAxis());
            dateAxis.title.text="Date"
            //create axis y
            let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
            valueAxis.title.text="Number of Log"

            //create first line series
            let lineSeries = this.chart.series.push(new am4charts.LineSeries());
            lineSeries.dataFields.valueY = "success";
            lineSeries.dataFields.dateX = "date";
            lineSeries.name = "Success";
            lineSeries.strokeWidth = 3;

            //add bullet image
            let bullet = lineSeries.bullets.push(new am4charts.CircleBullet());
            bullet.circle.fill = am4core.color("#fff");
            bullet.circle.strokeWidth = 3;
            bullet.tooltipText = "Number of Success Log in {dateX}: {valueY} ";
            // square.alwaysShowTooltip = true;

            //create second line series
            let lineSeries2 = this.chart.series.push(new am4charts.LineSeries());
            lineSeries2.dataFields.valueY = "failed";
            lineSeries2.dataFields.dateX = "date";
            lineSeries2.name = "Failed";
            lineSeries2.strokeWidth = 3;

            let bullet2 = lineSeries2.bullets.push(new am4charts.CircleBullet());
            bullet2.circle.fill = am4core.color("#fff");
            bullet2.circle.strokeWidth = 3;
            bullet2.tooltipText = "Number of Failed Log in {dateX}: {valueY} ";
            
            //add legend
            this.chart.legend = new am4charts.Legend();
            this.chart.legend.position = "bottom";
            //add cursor
            this.chart.cursor = new am4charts.XYCursor();
        }
    }
}
</script>

<style scoped>
    .chartStyle{
        min-height: 350px;
        /* background-color: white; */
    }
</style>